import Head from "next/head";
import NavBar from "/components/shared/navigation/NavBar";
import HelpButton from "/components/shared/buttons/HelpButton";

export default function RoomLayout({
  background,
  swiper,
  children,
  showFooter = true,
  hideOverflow = false,
}) {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, height=device-height, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Head>

      <div
        className={`${background} h-[100vh] ${
          hideOverflow ? "overflow-hidden" : "overflow-y-auto"
        }`}
      >
        <NavBar />
        <div
          className={
            swiper
              ? "items-center justify-center h-full"
              : "flex flex-col items-center justify-center min-h-screen"
          }
        >
          {children}
          <div className="fixed bottom-6 left-6 z-50">
            <HelpButton />
          </div>
        </div>
        {showFooter && (
          <div className="hidden xl:block">
            <div className="fixed bottom-0 w-screen bg-gray-dark h-11 flex place-content-center text-white text-base uppercase">
              <a href="/impressum" className="mr-12">Impressum</a>
              <a href="/datenschutz" className="mr-12">Datenschutz</a>
              <a href="https://www.jt-bonn.de/unternehmen/allgemeine-geschaeftsbedingungen/" className="mr-12">AGB</a>
              <a href="/faq">FAQ</a>
            </div>
          </div>
        )}
      </div>
      {/*<RunningShowAgenda />*/}
    </>
  );
}
